import { createFileRoute } from '@tanstack/react-router'
import { AgentFunctionsPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/functions')({
  component: AgentFunctionsPage,
})
